import { KYMW1400Model } from '../kymw1400.model';
import { RegistKomaGoodsModel } from '../vo/regist-koma-goods.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * コマ商品情報登録コマンド
 *
 * @export
 * @class RegistKomaGoodsService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class RegistKomaGoodsService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: KYMW1400Model = null;
  private vo: RegistKomaGoodsModel = null;
  private successFunction: Function = null;
  private pCodeList: Array<string>;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistKomaGoodsService
   */
  private getBody(): PlessRequest {
    const combinations = this.vo.komaInfoVOList.map(vo => ({
      condition: {
        SectionID: vo.sectionId,
        PositionX: vo.positionX,
        PositionY: vo.positionY,
        SizeW: vo.sizeW,
        SizeH: vo.sizeH,
        PCode: vo.pCode,
        PublishAmountLimitNum: vo.publishAmountLimitNum,
        ReceiptSOrderCode: vo.receiptSOrderCode,
        OrderNum6Digits: vo.orderNum6Digits,
        StartOrderCode: vo.startOrderCode,
        ItemCode: vo.itemCode
      }
    }));

    return new PlessRequest({
      regist: {
        KomaGoods: {
          parameter: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            CoopCode: this.vo.coopCode,
            PageNum: this.vo.pageNum,
            OrderGoodsFlg: this.vo.orderGoodsFlg
          },
          combination: combinations
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1400Model} model モデルクラス
   * @param {RegistKomaGoodsModel} vo パラメータ
   * @param {Array<string>} pCodeList Pコードリスト
   * @param {Function} successFunction 成功時後続処理
   * @memberof RegistKomaGoodsService
   */
  execute(model: KYMW1400Model, vo: RegistKomaGoodsModel, pCodeList: Array<string>, successFunction: Function) {
    this.model = model;
    this.vo = vo;
    this.pCodeList = pCodeList;
    this.successFunction = successFunction;
    this.send('KYMW14registKomaGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistKomaGoodsService
   */
  success(data: any) {
    // コマ情報追加
    this.model.selectedPage.updateKomaData(data[0].KomaInfo as any[]);

    this.model.selectedPageViewHelper.page.clear();

    // ページ情報取得要求(/KYMW14/getPage.xml)をサーバに送信する。
    this.model.kymw1400Component.dispatchGetPageEvent();

    // 計画値集計表取得要求(/KYMW14/getPlanSummaryTable.xml)をサーバに送信する。
    this.model.kymw1400Component.dispatchGetPlanSummaryTableEvent();

    // 成功イベントが設定されている場合
    if (this.successFunction != null) {
      if (this.pCodeList != null) {
        this.successFunction(this.pCodeList);
      } else {
        this.successFunction();
      }
    }
  }
}
